define("shared/components/shared/post/secondary/hashtag-suggestions/wrapper", ["exports", "@ember/component", "@ember/template-factory", "@ember/array", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts", "later/utils/array-methods", "later/utils/constants", "shared/utils/uuid"], function (_exports, _component, _templateFactory, _array, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _emberConcurrencyTs, _arrayMethods, _constants, _uuid) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _refetchCaptionHashtags, _isValidKeyboardEvent, _trackHashtagEvent, _formatHashtags, _isSearchHashtags;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/array",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts",0,"later/utils/array-methods",0,"later/utils/constants",0,"shared/utils/uuid"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.shouldSeeHashtagSuggestionsModal}}
    <div
      class="o--modalCard--secondary"
      {{did-insert this.trackModalOpened}}
      {{did-insert (perform this.fetchCaptionHashtags)}}
      {{will-destroy this.cancelFetchingCaptionHashtags}}
    >
      {{#if this.isTransitioning}}
        <Shared::LoadingSpinner />
      {{else}}
        <Shared::Post::Secondary::HashtagSuggestions::ModalHeader @showHelp={{true}} />
        {{#if this.isAutoTab}}
          {{#if this.canSeeCaptionHashtagSuggestions}}
            <section
              class="o--modalBody--secondary u--p__0 has--tallFooter"
              {{perfect-scroll
                this.scrollbarId
                wheelPropagation=true
                suppressScrollX=true
                scrollYMarginOffset=-1
                maxScrollbarLength=150
              }}
            >
              <Shared::Post::Secondary::HashtagSuggestions::Tabs
                @currentTab={{this.currentTab}}
                @setCurrentTab={{this.setCurrentTab}}
                @tabValues={{this.tabValues}}
                @trackTabClick={{this.trackChangedHashtagSourceEvent}}
              />
              <Shared::Post::Secondary::HashtagSuggestions::Auto
                @captionHashtags={{this.captionHashtags}}
                @currentText={{this.currentCaption}}
                @selectHashtag={{this.selectCaptionHashtag}}
                @selectedHashtags={{this.selectedCaptionHashtags}}
              />
            </section>
            <Shared::Post::Secondary::HashtagSuggestions::ModalFooter
              @insertHashtags={{this.insertHashtags}}
              @isDisabled={{not this.canInsert}}
              @numberOfSelectedHashtags={{this.selectedHashtags.length}}
              @toggle={{@toggle}}
            />
          {{else}}
            <section
              class="o--modalBody--secondary u--p__0 has--tallFooter"
              {{perfect-scroll
                this.scrollbarId
                wheelPropagation=true
                suppressScrollX=true
                scrollYMarginOffset=-1
                maxScrollbarLength=150
              }}
            >
              <Shared::Post::Secondary::HashtagSuggestions::Tabs
                @currentTab={{this.currentTab}}
                @setCurrentTab={{this.setCurrentTab}}
                @tabValues={{this.tabValues}}
                @trackTabClick={{this.trackChangedHashtagSourceEvent}}
              />
              <Shared::Post::Secondary::HashtagSuggestions::PaidUpgradeModal
                @href="https://help.later.com/hc/articles/360042772614#anchor_auto-hashtag-suggestions"
                @upgradeDescription={{if
                  this.isMobileSubscription
                  this.upgradeDescription
                  (t "hashtag_suggestions.limited.upgrade_modal_auto.description")
                }}
                @upgradeTitle={{t "hashtag_suggestions.limited.upgrade_modal_auto.title"}}
              />
            </section>
            {{#unless this.isMobileSubscription}}
              <div class="o--modalFooter">
                <Shared::Button::Upgrade
                  @additional="block"
                  @confirmLeave={{true}}
                  @feature="autoHashtags"
                  @location="hashtag suggestions"
                  @seamlessCheckoutSuccessCallback={{perform this.fetchCaptionHashtags}}
                  @size="large"
                  @text={{t "shared_phrases.upgrade_plan"}}
                  @trialText={{t "shared_phrases.start_trial"}}
                />
              </div>
            {{/unless}}
          {{/if}}
        {{else if this.isSearchTab}}
          <section
            class="o--modalBody--secondary u--p__0 has--tallFooter"
            {{perfect-scroll
              this.scrollbarId
              wheelPropagation=true
              suppressScrollX=true
              scrollYMarginOffset=-1
              maxScrollbarLength=150
            }}
          >
            {{#if this.isInstagram}}
              <Shared::Post::Secondary::HashtagSuggestions::Tabs
                @currentTab={{this.currentTab}}
                @setCurrentTab={{this.setCurrentTab}}
                @tabValues={{this.tabValues}}
                @trackTabClick={{this.trackChangedHashtagSourceEvent}}
              />
            {{/if}}
            <Shared::Post::Secondary::HashtagSuggestions::Search
              @currentText={{this.currentText}}
              @formatTrackingData={{this.formatTrackingData}}
              @hashtagQuery={{this.hashtagQuery}}
              @mediaItem={{@mediaItem}}
              @numberOfHashtagsSearches={{this.numberOfHashtagsSearches}}
              @planHasLimitedHashtagSearches={{this.planHasLimitedHashtagSearches}}
              @post={{@post}}
              @searchHashtags={{this.searchHashtags}}
              @selectHashtag={{this.selectSearchHashtag}}
              @selectedHashtags={{this.selectedSearchHashtags}}
              @updateHashtagQuery={{this.updateHashtagQuery}}
              @updateSearchHashtags={{this.updateSearchHashtags}}
              @updateSelectedSearchHashtags={{this.updateSelectedSearchHashtags}}
            />
          </section>
          <Shared::Post::Secondary::HashtagSuggestions::ModalFooter
            @insertHashtags={{this.insertHashtags}}
            @isDisabled={{not this.canInsert}}
            @numberOfSelectedHashtags={{this.selectedHashtags.length}}
            @toggle={{@toggle}}
          />
        {{/if}}
      {{/if}}
    </div>
  {{else}}
    <Shared::Post::Secondary::HashtagSuggestions::UpsellModal
      @cancelFetchingCaptionHashtags={{this.cancelFetchingCaptionHashtags}}
      @fetchCaptionHashtags={{this.fetchCaptionHashtags}}
      @isEligibleForTrial={{this.isEligibleForTrial}}
      @isInstagram={{this.isInstagram}}
      @planHasLimitedHashtagSearches={{this.planHasLimitedHashtagSearches}}
      @toggle={{@toggle}}
      @trackModalOpened={{this.trackModalOpened}}
      @upgradeDescription={{this.upgradeDescription}}
    />
  {{/if}}
  */
  {
    "id": "w0XX0lXy",
    "block": "[[[41,[30,0,[\"shouldSeeHashtagSuggestionsModal\"]],[[[1,\"  \"],[11,0],[24,0,\"o--modalCard--secondary\"],[4,[38,1],[[30,0,[\"trackModalOpened\"]]],null],[4,[38,1],[[28,[37,2],[[30,0,[\"fetchCaptionHashtags\"]]],null]],null],[4,[38,3],[[30,0,[\"cancelFetchingCaptionHashtags\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isTransitioning\"]],[[[1,\"      \"],[8,[39,4],null,null,null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,5],null,[[\"@showHelp\"],[true]],null],[1,\"\\n\"],[41,[30,0,[\"isAutoTab\"]],[[[41,[30,0,[\"canSeeCaptionHashtagSuggestions\"]],[[[1,\"          \"],[11,\"section\"],[24,0,\"o--modalBody--secondary u--p__0 has--tallFooter\"],[4,[38,6],[[30,0,[\"scrollbarId\"]]],[[\"wheelPropagation\",\"suppressScrollX\",\"scrollYMarginOffset\",\"maxScrollbarLength\"],[true,true,-1,150]]],[12],[1,\"\\n            \"],[8,[39,7],null,[[\"@currentTab\",\"@setCurrentTab\",\"@tabValues\",\"@trackTabClick\"],[[30,0,[\"currentTab\"]],[30,0,[\"setCurrentTab\"]],[30,0,[\"tabValues\"]],[30,0,[\"trackChangedHashtagSourceEvent\"]]]],null],[1,\"\\n            \"],[8,[39,8],null,[[\"@captionHashtags\",\"@currentText\",\"@selectHashtag\",\"@selectedHashtags\"],[[30,0,[\"captionHashtags\"]],[30,0,[\"currentCaption\"]],[30,0,[\"selectCaptionHashtag\"]],[30,0,[\"selectedCaptionHashtags\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,9],null,[[\"@insertHashtags\",\"@isDisabled\",\"@numberOfSelectedHashtags\",\"@toggle\"],[[30,0,[\"insertHashtags\"]],[28,[37,10],[[30,0,[\"canInsert\"]]],null],[30,0,[\"selectedHashtags\",\"length\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[11,\"section\"],[24,0,\"o--modalBody--secondary u--p__0 has--tallFooter\"],[4,[38,6],[[30,0,[\"scrollbarId\"]]],[[\"wheelPropagation\",\"suppressScrollX\",\"scrollYMarginOffset\",\"maxScrollbarLength\"],[true,true,-1,150]]],[12],[1,\"\\n            \"],[8,[39,7],null,[[\"@currentTab\",\"@setCurrentTab\",\"@tabValues\",\"@trackTabClick\"],[[30,0,[\"currentTab\"]],[30,0,[\"setCurrentTab\"]],[30,0,[\"tabValues\"]],[30,0,[\"trackChangedHashtagSourceEvent\"]]]],null],[1,\"\\n            \"],[8,[39,11],null,[[\"@href\",\"@upgradeDescription\",\"@upgradeTitle\"],[\"https://help.later.com/hc/articles/360042772614#anchor_auto-hashtag-suggestions\",[52,[30,0,[\"isMobileSubscription\"]],[30,0,[\"upgradeDescription\"]],[28,[37,12],[\"hashtag_suggestions.limited.upgrade_modal_auto.description\"],null]],[28,[37,12],[\"hashtag_suggestions.limited.upgrade_modal_auto.title\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[1,\"            \"],[10,0],[14,0,\"o--modalFooter\"],[12],[1,\"\\n              \"],[8,[39,14],null,[[\"@additional\",\"@confirmLeave\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@size\",\"@text\",\"@trialText\"],[\"block\",true,\"autoHashtags\",\"hashtag suggestions\",[28,[37,2],[[30,0,[\"fetchCaptionHashtags\"]]],null],\"large\",[28,[37,12],[\"shared_phrases.upgrade_plan\"],null],[28,[37,12],[\"shared_phrases.start_trial\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null]],[]]]],[]],[[[41,[30,0,[\"isSearchTab\"]],[[[1,\"        \"],[11,\"section\"],[24,0,\"o--modalBody--secondary u--p__0 has--tallFooter\"],[4,[38,6],[[30,0,[\"scrollbarId\"]]],[[\"wheelPropagation\",\"suppressScrollX\",\"scrollYMarginOffset\",\"maxScrollbarLength\"],[true,true,-1,150]]],[12],[1,\"\\n\"],[41,[30,0,[\"isInstagram\"]],[[[1,\"            \"],[8,[39,7],null,[[\"@currentTab\",\"@setCurrentTab\",\"@tabValues\",\"@trackTabClick\"],[[30,0,[\"currentTab\"]],[30,0,[\"setCurrentTab\"]],[30,0,[\"tabValues\"]],[30,0,[\"trackChangedHashtagSourceEvent\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[39,15],null,[[\"@currentText\",\"@formatTrackingData\",\"@hashtagQuery\",\"@mediaItem\",\"@numberOfHashtagsSearches\",\"@planHasLimitedHashtagSearches\",\"@post\",\"@searchHashtags\",\"@selectHashtag\",\"@selectedHashtags\",\"@updateHashtagQuery\",\"@updateSearchHashtags\",\"@updateSelectedSearchHashtags\"],[[30,0,[\"currentText\"]],[30,0,[\"formatTrackingData\"]],[30,0,[\"hashtagQuery\"]],[30,2],[30,0,[\"numberOfHashtagsSearches\"]],[30,0,[\"planHasLimitedHashtagSearches\"]],[30,3],[30,0,[\"searchHashtags\"]],[30,0,[\"selectSearchHashtag\"]],[30,0,[\"selectedSearchHashtags\"]],[30,0,[\"updateHashtagQuery\"]],[30,0,[\"updateSearchHashtags\"]],[30,0,[\"updateSelectedSearchHashtags\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,9],null,[[\"@insertHashtags\",\"@isDisabled\",\"@numberOfSelectedHashtags\",\"@toggle\"],[[30,0,[\"insertHashtags\"]],[28,[37,10],[[30,0,[\"canInsert\"]]],null],[30,0,[\"selectedHashtags\",\"length\"]],[30,1]]],null],[1,\"\\n      \"]],[]],null]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,16],null,[[\"@cancelFetchingCaptionHashtags\",\"@fetchCaptionHashtags\",\"@isEligibleForTrial\",\"@isInstagram\",\"@planHasLimitedHashtagSearches\",\"@toggle\",\"@trackModalOpened\",\"@upgradeDescription\"],[[30,0,[\"cancelFetchingCaptionHashtags\"]],[30,0,[\"fetchCaptionHashtags\"]],[30,0,[\"isEligibleForTrial\"]],[30,0,[\"isInstagram\"]],[30,0,[\"planHasLimitedHashtagSearches\"]],[30,1],[30,0,[\"trackModalOpened\"]],[30,0,[\"upgradeDescription\"]]]],null],[1,\"\\n\"]],[]]]],[\"@toggle\",\"@mediaItem\",\"@post\"],false,[\"if\",\"did-insert\",\"perform\",\"will-destroy\",\"shared/loading-spinner\",\"shared/post/secondary/hashtag-suggestions/modal-header\",\"perfect-scroll\",\"shared/post/secondary/hashtag-suggestions/tabs\",\"shared/post/secondary/hashtag-suggestions/auto\",\"shared/post/secondary/hashtag-suggestions/modal-footer\",\"not\",\"shared/post/secondary/hashtag-suggestions/paid-upgrade-modal\",\"t\",\"unless\",\"shared/button/upgrade\",\"shared/post/secondary/hashtag-suggestions/search\",\"shared/post/secondary/hashtag-suggestions/upsell-modal\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/wrapper.hbs",
    "isStrictMode": false
  });

  var Tabs;

  (function (Tabs) {
    Tabs["Auto"] = "auto";
    Tabs["Search"] = "search";
  })(Tabs || (Tabs = {}));

  let WrapperComponent = (_dec = (0, _service.inject)('schedule/caption-hashtags'), (_class = (_refetchCaptionHashtags = /*#__PURE__*/new WeakSet(), _isValidKeyboardEvent = /*#__PURE__*/new WeakSet(), _trackHashtagEvent = /*#__PURE__*/new WeakSet(), _formatHashtags = /*#__PURE__*/new WeakSet(), _isSearchHashtags = /*#__PURE__*/new WeakSet(), class WrapperComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _isSearchHashtags);

      _classPrivateMethodInitSpec(this, _formatHashtags);

      _classPrivateMethodInitSpec(this, _trackHashtagEvent);

      _classPrivateMethodInitSpec(this, _isValidKeyboardEvent);

      _classPrivateMethodInitSpec(this, _refetchCaptionHashtags);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);

      _initializerDefineProperty(this, "secondaryModal", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor6, this);

      _initializerDefineProperty(this, "scheduleCaptionHashtags", _descriptor7, this);

      _defineProperty(this, "Tabs", Tabs);

      _initializerDefineProperty(this, "hashtagQuery", _descriptor8, this);

      _initializerDefineProperty(this, "searchHashtags", _descriptor9, this);

      _initializerDefineProperty(this, "selectedSearchHashtags", _descriptor10, this);

      _initializerDefineProperty(this, "selectedCaptionHashtags", _descriptor11, this);

      _initializerDefineProperty(this, "currentTab", _descriptor12, this);

      this.currentTab = this.canSeeCaptionHashtagSuggestions ? this.Tabs.Auto : this.Tabs.Search;
    }

    get shouldSeeHashtagSuggestionsModal() {
      return this.canSearchHashtags || this.canSeeCaptionHashtagSuggestions;
    }

    get canSearchHashtags() {
      // Note: the BE also checks if the user has hashtag searches remaining on their plan
      return Boolean(this.auth.currentAccount.canSmartHashtags);
    }

    get canSeeCaptionHashtagSuggestions() {
      return Boolean(this.auth.currentAccount.canCaptionHashtags && this.isInstagram);
    }

    get isEligibleForTrial() {
      return Boolean(this.auth.currentAccount?.canTrialPlan);
    }

    get isInstagram() {
      return this.args.socialProfile?.isInstagram;
    }

    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }

    get isTransitioning() {
      return this.secondaryModal.isTransitioning;
    }

    get extraTrackingData() {
      let extraTrackingData = {
        source: this.isAutoTab ? 'captions' : 'search'
      };

      if (this.args.socialProfile?.isInstagram && !this.isAutoTab) {
        extraTrackingData = { ...extraTrackingData,
          added_to_captions: !this.clickedFromFirstComment,
          added_to_first_comment: this.clickedFromFirstComment
        };
      }

      return extraTrackingData;
    }

    get tabValues() {
      return Object.values(this.Tabs);
    }

    get isAutoTab() {
      return this.currentTab === this.Tabs.Auto;
    }

    get isSearchTab() {
      return this.currentTab === this.Tabs.Search;
    }

    get selectedHashtags() {
      return this.isAutoTab ? this.selectedCaptionHashtags : this.selectedSearchHashtags;
    }

    get canInsert() {
      return !(0, _utils.isEmpty)(this.selectedHashtags);
    }

    get captionHashtags() {
      return this.scheduleCaptionHashtags.data;
    }

    get numberOfHashtagsSearches() {
      return this.subscriptions.subscriptionPlan?.numberOfHashtagSearches ?? 0;
    }

    get planHasLimitedHashtagSearches() {
      return Boolean(this.subscriptions.subscriptionPlan?.hasLimitedHashtagSearches);
    }

    get platform() {
      return this.subscriptions.platform;
    }

    get scrollbarId() {
      const socialProfileId = (0, _object.get)(this.args.socialProfile || {}, 'id');
      return `${(0, _uuid.default)()}__${socialProfileId}`;
    }

    get clickedFromFirstComment() {
      return this.secondaryModal.isClickedFromFirstComment(this.args.postElementId);
    }

    get currentCaption() {
      return this.args.mediaItem ? this.args.mediaItem.defaultCaption : `${this.args.post.caption} ${this.args.post.firstComment}`;
    }

    get currentText() {
      if (this.args.mediaItem) {
        return this.args.mediaItem.defaultCaption;
      } else if (this.clickedFromFirstComment) {
        return this.args.post.firstComment ?? '';
      }

      return this.args.post.caption;
    }

    get upgradeDescription() {
      if (this.isMobileSubscription) {
        const translationString = this.isEligibleForTrial ? 'plans.mobile.upgrade.auto_hashtag_suggestions_trial' : 'plans.mobile.upgrade.auto_hashtag_suggestions';
        return this.intl.t(translationString, {
          platform: this.subscriptions.platform
        });
      }

      const translationString = this.isEligibleForTrial ? 'hashtag_suggestions.search.upgrade_subtitle' : 'hashtag_suggestions.limited.upgrade.description_alt';
      return this.intl.t(translationString);
    }

    willDestroy() {
      super.willDestroy();
      document.removeEventListener('keyup', _classPrivateMethodGet(this, _refetchCaptionHashtags, _refetchCaptionHashtags2));
    }

    cancelFetchingCaptionHashtags() {
      this.scheduleCaptionHashtags.handleDeactivate();
    }

    setCurrentTab(tab) {
      this.currentTab = tab;
    }

    formatTrackingData(trackingData) {
      const {
        isCarouselPost,
        location,
        mediaItem,
        post,
        postMediaItems,
        socialProfile
      } = this.args;
      const postMediaItem = postMediaItems?.firstObject;
      const media_id = mediaItem?.id || postMediaItem?.get('mediaItem')?.get('id') || 'null_value';
      let type;

      if (post?.isText) {
        type = post.textPostType;
      } else {
        type = isCarouselPost ? 'multi-photo' : post?.gramType || mediaItem?.mediaType;
      }

      const postSegmentData = {
        media_id,
        location,
        type,
        social_platform: socialProfile?.profileType ? [socialProfile.profileType] : [],
        profile_handles: socialProfile?.nickname ? [socialProfile.nickname] : []
      };
      return Object.assign({}, postSegmentData, trackingData);
    }

    selectSearchHashtag(tag) {
      if (this.selectedSearchHashtags.includes(tag)) {
        this.selectedSearchHashtags.removeObject(tag);
      } else {
        this.selectedSearchHashtags.pushObject(tag);
      }
    }

    selectCaptionHashtag(tag) {
      if (this.selectedCaptionHashtags.includes(tag)) {
        this.selectedCaptionHashtags.removeObject(tag);
      } else {
        this.selectedCaptionHashtags.pushObject(tag);
      }
    }

    trackChangedHashtagSourceEvent(tab) {
      const isClickedTabCaption = tab === this.Tabs.Auto;

      _classPrivateMethodGet(this, _trackHashtagEvent, _trackHashtagEvent2).call(this, 'changed-hashtag-suggestion-source', {
        selected_source_tab: isClickedTabCaption ? 'captions' : 'search'
      });
    }

    insertHashtags() {
      const spaceBreak = this.currentText && this.currentText.length ? '\n' : '';

      const newText = this.currentText + spaceBreak + _classPrivateMethodGet(this, _formatHashtags, _formatHashtags2).call(this, this.selectedHashtags);

      if (this.args.mediaItem) {
        (0, _object.set)(this.args.mediaItem, 'defaultCaption', newText);
      } else if (this.clickedFromFirstComment) {
        (0, _object.set)(this.args.post, 'firstComment', newText);
      } else {
        (0, _object.set)(this.args.post, 'caption', newText);
      }

      if (this.isSearchTab && _classPrivateMethodGet(this, _isSearchHashtags, _isSearchHashtags2).call(this, this.selectedHashtags)) {
        this.searchHashtags.removeObjects(this.selectedHashtags);
      }

      if (this.isAutoTab && !_classPrivateMethodGet(this, _isSearchHashtags, _isSearchHashtags2).call(this, this.selectedHashtags)) {
        this.scheduleCaptionHashtags.removeHashtags(this.selectedHashtags);
      }

      _classPrivateMethodGet(this, _trackHashtagEvent, _trackHashtagEvent2).call(this, 'suggested-hashtags-inserted', this.extraTrackingData);

      if (this.isAutoTab) {
        this.selectedCaptionHashtags = (0, _array.A)();
      }

      if (this.isSearchTab) {
        this.selectedSearchHashtags = (0, _array.A)();
      }
    }

    updateHashtagQuery(value) {
      this.hashtagQuery = value;
      return value;
    }

    updateSearchHashtags(value) {
      this.searchHashtags = value;
      return value;
    }

    updateSelectedSearchHashtags(value) {
      this.selectedSearchHashtags = value;
      return value;
    }

    trackModalOpened() {
      this.segment.track('opened-hashtag-suggestions', {
        location: this.router.currentRouteName.includes('media') ? 'media_item' : 'post-builder'
      });
    }

    *fetchCaptionHashtags() {
      if (this.canSeeCaptionHashtagSuggestions) {
        yield (0, _emberConcurrencyTs.taskFor)(this.scheduleCaptionHashtags.fetchCaptionHashtags).perform(this.args.socialProfile?.id, this.currentCaption);
        document.addEventListener('keyup', _classPrivateMethodGet(this, _refetchCaptionHashtags, _refetchCaptionHashtags2).bind(this));
      }
    } // Note: we needed to use a custom event listener instead of ember-render-modifier hooks
    // because the keyup event is occuring outside this component in the post caption element


  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "scheduleCaptionHashtags", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hashtagQuery", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "searchHashtags", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedSearchHashtags", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "selectedCaptionHashtags", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "currentTab", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "cancelFetchingCaptionHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelFetchingCaptionHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentTab", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formatTrackingData", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "formatTrackingData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectSearchHashtag", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSearchHashtag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectCaptionHashtag", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectCaptionHashtag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangedHashtagSourceEvent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangedHashtagSourceEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "insertHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateHashtagQuery", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateHashtagQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSearchHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSearchHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSelectedSearchHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelectedSearchHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackModalOpened", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackModalOpened"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchCaptionHashtags", [_emberConcurrency.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "fetchCaptionHashtags"), _class.prototype)), _class));
  _exports.default = WrapperComponent;

  function _refetchCaptionHashtags2(event) {
    if (!_classPrivateMethodGet(this, _isValidKeyboardEvent, _isValidKeyboardEvent2).call(this, event)) {
      return;
    }

    if (this.canSeeCaptionHashtagSuggestions) {
      (0, _emberConcurrencyTs.taskFor)(this.scheduleCaptionHashtags.refetchCaptionHashtags).perform(this.args.socialProfile?.id, this.currentCaption);
    }
  }

  function _isValidKeyboardEvent2(_ref) {
    let {
      code,
      target
    } = _ref;

    if (!(target instanceof Element)) {
      return false;
    }

    const targetPostElementId = target.getAttribute('data-post-element-id');
    const fromCorrectPost = this.args.postElementId === targetPostElementId;

    if (targetPostElementId && !fromCorrectPost) {
      return false;
    }

    if (_constants.KEYBOARD_ARROW_KEYCODES.includes(code)) {
      return false;
    }

    return true;
  }

  function _trackHashtagEvent2(name) {
    let extraTrackingData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const hashtagTypes = this.selectedHashtags.map(selectedHashtag => {
      if ('type' in selectedHashtag) {
        return selectedHashtag.type;
      }

      return '';
    });
    const uniqueTypes = (0, _arrayMethods.findUnique)(hashtagTypes).filter(Boolean);
    const hashtag_type = uniqueTypes.length ? uniqueTypes : ['captions'];
    const trackingData = this.formatTrackingData({
      hashtag_count: Number(this.selectedHashtags.length),
      hashtag_list: this.selectedHashtags.map(selectedHashtag => selectedHashtag.hashtag),
      hashtag_type,
      ...extraTrackingData
    });
    this.segment.track(name, trackingData);
  }

  function _formatHashtags2(tagsArray) {
    return tagsArray.map(_ref2 => {
      let {
        hashtag
      } = _ref2;
      return `#${hashtag}`;
    }).join(' ');
  }

  function _isSearchHashtags2(hashtags) {
    return hashtags.filter(hashtag => hashtag.type === undefined).length === 0;
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});